import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { parseBookSearch, type BookFilters, type BookSearch } from '@/lib/fundraising/bookFilters';
import { ProspectsBook } from '@/components/fundraising';

// The Prospects tab — the Fundraising page's one list of the campaign's Prospects. Gated on
// Fundraising:Manage; the /admin shell also admits Fundraising:View so a user with only this area can
// reach it. Its filters and search live in the URL, and so does the person open over it (`?person=`), so Back
// closes them and a shared link reopens them.
export const Route = createFileRoute('/admin/fundraising/')({
  validateSearch: parseBookSearch,
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, '/admin/fundraising');
  },
  component: ProspectsRoute,
});

function ProspectsRoute() {
  // Read apart, so stepping from one person to the next leaves the filters (compared field by field) the
  // same object, and the book behind the dialog isn't redrawn.
  const filters = Route.useSearch({ select: withoutPerson });
  const person = Route.useSearch({ select: (search) => search.person });
  const navigate = Route.useNavigate();
  // Each change replaces the entry, so Back leaves the book rather than undoing a keystroke.
  const onFiltersChange = useCallback((next: BookFilters) => void navigate({ search: next, replace: true }), [navigate]);
  return <ProspectsBook filters={filters} person={person} onFiltersChange={onFiltersChange} />;
}

const withoutPerson = ({ person: _person, ...filters }: BookSearch): BookFilters => filters;
